module.exports = __webpack_public_path__ + "img/logo.c26b716d.png";